<!-- 队伍规则 -->
<template>
  <div>
    <button :class="$style['btn-question']" @click="$refs.rule.show()" />
    <popup-frame ref="rule" size="lg">
      <div :class="$style['rules-content']" v-html="teamRule" />
    </popup-frame>
  </div>
</template>

<script>
import { PopupFrame } from '@/components/widgets'
import { mapGetters } from 'vuex'

export default {
  name: 'TeamRules',
  components: {
    PopupFrame
  },
  computed: {
    ...mapGetters(['teamRule'])
  }
}
</script>

<style lang="less" module>
.btn-question {
  .size(0.4rem);
  .background-fill('./images/icon-question.png');
}

.rules-content {
  padding: 0.2rem 0.3rem 0;
  font-size: 0.22rem;
  line-height: 1.8;

  &::before {
    .size(7.08rem, 3.17rem);
    .background-fill('./images/title.png');

    content: '';
    position: absolute;
    top: -0.3rem;
    left: 0;
    pointer-events: none;
  }
}
</style>
